import React from 'react';

export default () => (
  <div className='flex'>
    <div className='spinner col-c-c'>
      <div />
    </div>
  </div>
);
